module.exports = __webpack_public_path__ + "public/images/partners/partner-4.aa667f986b059a939c0a7a9835da97d7.png";